import appBulkInvoiceItemTypesUpload from "../../views/appSettings/bulkInvoiceItemTypesUploadView.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("bulkinvoiceitemtypesupload", {
    url: "captain-finance/bulk",
    parent: "app",
    views: {
      view: {
        template: appBulkInvoiceItemTypesUpload,
      },
    },
    reloadOnSearch: false,
    data: { title: "BulkInvoiceItemTypesUpload" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUpload/bulkInvoiceItemTypesUpload.urls.js